"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const contract_errors_1 = __importDefault(require("./contract-errors"));
const ERROR_ID_SCRIPT_REJECTED = 'proto.007-PsDELPH1.michelson_v1.script_rejected';
const ErrorUtils = {
    contractErrorFromTaquitoException: function (exception) {
        const errors = exception.errors;
        if (errors === undefined) {
            return contract_errors_1.default.Unknown;
        }
        for (let i = 0; i < errors.length; i++) {
            const error = errors[i];
            const id = error.id;
            if (id === undefined) {
                continue;
            }
            if (id === ERROR_ID_SCRIPT_REJECTED) {
                const withValue = error.with;
                if (withValue === undefined) {
                    continue;
                }
                const errorCodeString = withValue.int;
                if (errorCodeString === undefined) {
                    continue;
                }
                const errorCode = parseInt(errorCodeString);
                if (Number.isNaN(errorCode)) {
                    continue;
                }
                return errorCode;
            }
        }
        return contract_errors_1.default.Unknown;
    },
};
exports.default = ErrorUtils;
//# sourceMappingURL=error-utils.js.map